export default __webpack_public_path__ + "static/media/WelcomeView_1-min.6fa13753.png";